export default __webpack_public_path__ + "static/media/hall1.1ce732aa.png";